<template lang="pug">
  .tko-tariff
    .body.body-table
      .table-choose-panel
        div#tarif(style='margin-bottom:20px')
          .e-table.table.table_tariff.table_static-last-child
            div.e-table__body-wrapper.table__body-wrapper
              .e-table__body.table__body
                div.e-table__row.table__row.table__row_justify-start
                  .e-table__col.table__col.e-table__head.table__head.table__col_double-width(v-for="(col, i) of columns" :key="col") {{ col }}
                  .e-table__col.table__col.table__col_double-width(v-for="(year, idx) of optionalYears") {{ year.base_year ? `Базовый год для расчета (${year.year})` : year.year }}
                .e-table__row.table__row.table__row_justify-start(v-for="(row, index) in rows")
                  .e-table__col.table__col.table__col_double-width {{row.label}}
                  .e-table__col.table__col.table__col_double-width {{ row.unit }}
                  .e-table__col.table__col.table__col_double-width(v-for="(year, idx) of optionalYears" :key="year.id")
                    input.input(
                      type="number"
                      v-model="year[row.name]"
                      :class="{'auto-check': year[row.autoCheck]}"
                      :title="`${row.autoCheck && year[row.autoCheck] ? row.autoCheckText : ''}`"
                      :disabled="row.disabled"
                      :readonly="readOnly"
                      @change="formatValue(row.name, idx, row.fixed ? row.fixed : 2)"
                      @input="inputValue($event.target.value, row.name, idx)"
                    )
</template>

<script>
export default {
  name: 'TariffTable',
  props: {
    columns: {
      type: Array,
      default: () => [],
    },
    rows: {
      type: Array,
      default: () => [],
    },
    urlPost: {
      type: String,
      default: '',
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      optionalYears: [],
      baseYear: null,
    }
  },
  methods: {
    inputValue(event, name, idx) {
      if ((name === 'ipc' || name === 'ro') && event >= 100) {
        this.optionalYears[idx][name] = 99.99
      }
    },
    formatValue(name, idx, fix) {
      this.optionalYears[idx][name] = Number(
        this.optionalYears[idx][name]
      ).toFixed(fix)
    },
    saveTable() {
      return new Promise((resolve) => {
        this.optionalYears.map(async (year) => {
          // eslint-disable-next-line no-unused-vars
          const { single_tariff, single_tariff_cubic, nvv_ro, ...rest } = year
          await this.$store.dispatch('createModel', {
            url: this.urlPost,
            data: { ...rest, apo_id: this.$route.params.id },
          })
        })
        resolve()
      })
    },
    setYears(data) {
      this.optionalYears = []
      for (let key in data) {
        this.optionalYears.push(data[key])
      }
    },
    addFunction(year) {
      const data = { ...year }
      this.rows.map((i) => {
        data[i.name] = null
        if (i.name === 'cost_reduction_ratio') data[i.name] = 0.4
      })
      this.optionalYears.push(data)
    },
  },
}
</script>

<style scoped lang="scss">
.half-block {
  display: flex;
  gap: 15px;
}
.auto-check {
  color: red !important;
}
</style>
